import styles from './BeelineOrderList.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {AddFeedBackInt} from "../../ClientLK/OrderList/ClientOrderList";
import {Button} from "react-bootstrap";
import TableItem, {TableItemCurrentStateInt} from "../../FormTemplate/TableItem/TableItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ButtonContainer from "../../FormTemplate/ButtonContainer/ButtonContainer";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";


interface ISolutionItem
{
    id:number
    code:number
    text:string
}


interface IUpdateStatus
{
    orderId:string
    text:string
}

interface IOrderItem{
//    [key:string]:any
    id:number
    state: number
    subState:number
    deliveryState:number
    customerId:number
    orderId:string
    regModeName:string
    ctn: string
    tempCtn:string
    icc:string
    family:string
    processName:string
    processItemName: string
    date: Date,
    lastCheck:Date,
    lastCheckText:string
    adminNote:string,
    regMode:number
    sameOper:boolean

}

export default function BeelineOrderList(){
    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()
    const orderListData = useRef<{
        mode:number // 0- активные 1-все 2-платные все
        xData?: string
    }>()
    const [ldrOrderList,rsOrderList,exOrderList] = useApiQuery("/beeline/lk/order/list","post",orderListData);


    const updateOrderData = useRef<IUpdateStatus>()
    const [ldrUpdateOrder,rsUpdateOrder,exUpdateOrder] = useApiQuery("/beeline/lk/order/update","post",updateOrderData);


    const outOrderData = useRef<{
        orderId:string
    }>()
    const [ldrOutOrder,rsOutOrder,exOutOrder] = useApiQuery("/beeline/lk/order/delivered","post",outOrderData);


    const [currentOrder, setCurrentOrder] = useState<any|IOrderItem>()
    const refState = useRef<ErrorLineItemRef>(null)

    const [orderList, setOrderList] = useState<IOrderItem[]>([])
    const [solutionId ,setSolutionId] = useState(-1)
    const [solutionList, setSolutionList] = useState<ISolutionItem[]>([
        //Временный номер
        {
            id:30,
            code:3,
            text: "Заявление еще не обработано"
        },
        {
            id:0,
            code:3,
            text: "Временный номер готов, заявление обработано"
        },
        {
            id:40,
            code:3,
            text: "Отказ, клиент отказался от переноса"
        },
        {
            id:1,
            code:3,
            text: "Отказ, ошибка в персональных данных"
        },
        {
            id:27,
            code:3,
            text: "Отказ, нет 18 лет"
        },
        {
            id:2,
            code:3,
            text: "Ошибка, нужно повторить заявление"
        },
        {
            id:28,
            code:3,
            text: "Отказ, другая причина"
        },



        //смена ФО


        {
            id:31,
            code:55,
            text: "Заявление еще не обработано"
        },
        {
            id:3,
            code:55,
            text: "Ожидание смены ФО, все норм"
        },
        {
            id:4,
            code:55,
            text: "Тариф сменен [ ФО ]"
        },
        {
            id:5,
            code:55,
            text: "Отказ, не верные персональные данные"
        },
        {
            id:6,
            code:55,
            text: "Отказ, нет 18 лет"
        },
        {
            id:7,
            code:55,
            text: "Отказ, задолженность"
        },
        {
            id:8,
            code:55,
            text: "Отказ, другая причина"
        },
        {
            id:24,
            code:55,
            text: "Ошибка, нужно повторить заявление"
        },

        //MNP

        {
            id:9,
            code:5,
            text: "Ожидание переноса, все норм"
        },
        {
            id:10,
            code:5,
            text: "Номер удачно перенесен в beeline"
        },
        {
            id:11,
            code:5,
            text: "Отказ, клиент отказался от переноса"
        },
        {
            id:12,
            code:5,
            text: "Отказ, не верные персональные данные"
        },
        {
            id:13,
            code:5,
            text: "Отказ, нет 18 лет"
        },
        {
            id:14,
            code:5,
            text: "Отказ, задолженность"
        },
        {
            id:15,
            code:5,
            text: "Отказ, номер блокирован"
        },
        {
            id:16,
            code:5,
            text: "Отказ, не прошло 30 дней"
        },
        {
            id:17,
            code:5,
            text: "Отказ, другая причина"
        },
        {
            id:25,
            code:5,
            text: "Ошибка, нужно повторить заявление"
        },


        //new
        {
            id:32,
            code:6,
            text: "Заявление еще не обработано"
        },
        {
            id:18,
            code:6,
            text: "Ожидание готовности номера"
        },
        {
            id:19,
            code:6,
            text: "Номер готов, заявление обработано"
        },
        {
            id:20,
            code:6,
            text: "Отказ, не верные персональные данные"
        },
        {
            id:21,
            code:6,
            text: "Отказ, нет 18 лет"
        },
        {
            id:22,
            code:6,
            text: "Отказ, ошибка обработки заявления, нужно повторить"
        },
        {
            id:23,
            code:6,
            text: "Отказ, другая причина"
        },







    ])



    useEffect(()=>{
        loadOrderList(0)
    },[orderListData])

    useEffect(()=>{
        console.log("orderList", orderList)
        },[orderList])

    useEffect(()=>{
        //setSolutionId(-1)
    },[currentOrder])


    const handleOutOrder = ()=>{
        if(! currentOrder ) return
        outOrderData.current = {
            orderId: currentOrder?.orderId
        }
        exOutOrder().then((e)=>{
            if(e?.success){
                if(refState.current)refState.current.show("Статус отправлен",false,4000)
                loadOrderList(1)
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        })
    }

    const handleUpdateOrder = ()=>{
        if(! currentOrder || solutionId <0) return
        const sol = solutionList?.filter((item)=>item?.id === solutionId)
        if(! sol?.length) return;
        updateOrderData.current = {
            orderId: currentOrder?.orderId,
            text: sol[0]?.text
        }

        exUpdateOrder().then((e)=>{
            if(e?.success){
                if(refState.current)refState.current.show("Статус отправлен",false,4000)
                loadOrderList(1)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        })

    }

    const loadOrderList = (mode: number)=>{
        orderListData.current = {
            mode: mode,
            xData: currentOrder ? currentOrder?.orderId : undefined
        }



        exOrderList().then((e)=>{
            if(e?.success){
                if(e?.payload && Array.isArray(e?.payload)){
                    const data = e?.payload
                    const x:IOrderItem[] = data?.map((item)=>{
                        return{
                            id: item?.id,
                            state: item?.stateOne?.state,
                            subState: item?.stateOne?.subState,

                            deliveryState: item?.deliveryOne?.state,
                            customerId: item?.deliveryOne?.customerId,


                            regMode: item?.regMode,
                            sameOper: !!item?.simOne?.sameOper,
                            date: (item?.createdAt),
                            ctn: item?.simOne?.ctn ? item?.simOne?.ctn : "-",
                            tempCtn: item?.simOne?.tempCtn ? item?.simOne?.tempCtn : "-",
                            family: item?.dkpOne?.family ? item?.dkpOne?.family : "-",
                            orderId: item?.orderId,
                            icc: item?.simOne?.icc ? item?.simOne?.icc : "-",
                            processName: item?.processName ? item?.processName : "-",
                            processItemName: item?.processItemName ? item?.processItemName : "-",
                            regModeName: item?.regModeName ? item?.regModeName : "-",
                            lastCheck: item?.lastCheck,
                            lastCheckText: item?.lastCheckText ? item?.lastCheckText : "-",
                            adminNote: item?.adminNote,
                        }


                    })

                    switch (mode){
                        case 0:
                            setOrderList(x)
                            break
                        case 1:
                            const px = orderList?.map((item)=>{

                                if(x?.length  && item?.orderId === x[0]?.orderId) return x[0]
                                return item
                            })
                            setOrderList(px)
                            break

                    }

                    return

                }

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })


    }


    const buildSolution = ()=>{

        if(!currentOrder || currentOrder?.state === undefined) return null
        const lasDateText = currentOrder?.lastCheck?.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/) ? new Date(currentOrder?.lastCheck)?.toLocaleString() : "не было"


        const x = solutionList?.filter((item)=> {
            if(currentOrder?.sameOper && currentOrder?.regMode === 10){
                if(item.code === 55) return true
                return  false
            }

            if(currentOrder?.state === item?.code) return  true
            return false



        })
        const mp = x?.map((item,idx)=>{
            return (
                <div key={idx} className={["col-4",styles.slItemCont].join(' ')}
                    onClick={()=>setSolutionId(item?.id)}
                >
                    <div className={[styles.slItem, item?.id === solutionId ? styles.slItemActive : ""].join(' ')}>
                        {item?.text}
                    </div>
                </div>
            )

        })

        return (
            <div className={styles.slCont}>
                <div className={styles.slTitle}>Последняя проверка статуса<span>[{lasDateText}]</span></div>

                <div className={"row w-100 g-0 align-items-stretch"}>
                    {mp}
                </div>


            </div>
        )


    }

    const buildSaloonState = ()=>{
        if(!currentOrder || currentOrder?.customerId !==4 || currentOrder?.deliveryState === 5)return null
        return (
            <div className={styles.ibCont}>
                <div>Если сменился ICC, то выдан в салоне</div>
                <button type="button" className="btn btn-secondary "
                    onClick={(e)=>handleOutOrder()}
                    disabled={ldrOutOrder}
                >Выдан в салоне</button>
            </div>
        )

    }

    return(
        <div className={styles.mainCont}>

            <MainFormTemplate title={`Данные заявки ${currentOrder ? `[ ${currentOrder?.orderId} ]` : ""}`} maxWidth={"100%"} >
                <div className={styles.titleCont}>
                    <ActiveRecordItem active={!!currentOrder}></ActiveRecordItem>
                    <WaitLoader loading={ldrOrderList || ldrUpdateOrder || ldrOutOrder} api={rsOrderList} onlyLoading={true}>

                    </WaitLoader>

                </div>
                <div className={"row w-100 g-1"}>
                    <div className={["col-xl-4 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.orderId ? currentOrder?.orderId : ""}
                            mode={"i"}
                            info={"Номер заказа"}
                            title={"Номер заказа"}
                            titleShift={2}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-4 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.date ? new Date(currentOrder?.date).toLocaleString()  : "-"}
                            mode={"i"}
                            info={"Дата создания"}
                            title={"Дата"}
                            titleShift={-1}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-4 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.regModeName}
                            mode={"i"}
                            info={"Тип заказа"}
                            title={"Тип заказа"}
                            titleShift={-1}
                        ></InputItem>
                    </div>

                </div>
                <div className={"row w-100 g-1"}>
                    <div className={["col-xl-4 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.family ? currentOrder?.family : "-"}
                            mode={"i"}
                            info={"Фамилия"}
                            title={"Фамилия"}
                            titleShift={2}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-8 col-lg-8 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.adminNote ? currentOrder?.adminNote : "-"}
                            mode={"i"}
                            info={"Заявка"}
                            title={"Заявка [ beeline ]"}
                            titleShift={-1}
                        ></InputItem>
                    </div>
                </div>
                <div className={"row w-100 g-1"}>
                    <div className={["col-xl-4 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.ctn ? currentOrder?.ctn : "-"}
                            mode={"i"}
                            info={"Номер"}
                            title={"Номер"}
                            titleShift={0}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-4 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.tempCtn ? currentOrder?.tempCtn : "-"}
                            mode={"i"}
                            info={"Врем.номер"}
                            title={"Врем.номер"}
                            titleShift={0}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-4 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.icc ? currentOrder?.icc : "-"}
                            mode={"i"}
                            info={"ICC"}
                            title={"ICC"}
                            titleShift={-1}
                        ></InputItem>
                    </div>

                </div>
                <div className={"row w-100 g-1"}>
                    <div className={["col-xl-6 col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.processName ? currentOrder?.processName : "-"}
                            mode={"i"}
                            info={"Процесс"}
                            title={"Процесс"}
                            titleShift={0}
                        ></InputItem>
                    </div>
                    <div className={["col-xl-6 col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.processItemName ? currentOrder?.processItemName : "-"}
                            mode={"i"}
                            info={"Задача"}
                            title={"Задача"}
                            titleShift={0}
                        ></InputItem>
                    </div>

                </div>
                <div className={"row w-100 g-1"}>
                    <div className={["col-xl-12 col-lg-12 col-md-12", styles.lsFont].join(' ')}>
                        <InputItem
                            val={currentOrder?.lastCheckText}
                            mode={"i"}
                            info={"Последнее"}
                            title={"Последняя проверка"}
                            titleShift={-1}
                        ></InputItem>
                    </div>

                </div>


                <div className={"row w-100 g-0 "}>
                        {buildSolution()}
                </div>
                <div className={"row w-100 g-0 my-1"}>
                    <ErrorLineItem ref={refState} ></ErrorLineItem>
                </div>
                <ButtonContainer my={20} clsCont={styles.btCont}>
                    <button type="button" className={["btn btn-secondary", styles.jButt].join(' ')}
                            onClick={(e)=>handleUpdateOrder()}
                            disabled={!currentOrder || solutionId < 0 || ldrUpdateOrder}
                    >Отправить статус</button>
                    {buildSaloonState()}

                </ButtonContainer>


            </MainFormTemplate>



                <TableItem
                    column={[
                        {
                            title:"Заказ",
                            type: 0,
                            maxLen: 11,
                            fieldId:"orderId",
                            mode: "sf",
                        },
                        {
                            title:"Дата заявки",
                            type: 2,
                            maxLen: 10,
                            fieldId:"date",
                            mode: "sf",
                        },
                        {
                            title:"Фамилия",
                            type: 0,
                            maxLen: 30,
                            fieldId:"family",
                            mode: "sf",
                        },
                        {
                            title:"Тип",
                            type: 0,
                            maxLen: 20,
                            fieldId:"regModeName",
                            mode: "sf",
                        },
                        {
                            title:"Номер",
                            type: 0,
                            maxLen: 20,
                            fieldId:"ctn",
                            mode: "sf",
                        },
                        {
                            title:"Процесс",
                            type: 0,
                            maxLen: 30,
                            fieldId:"processName",
                            mode: "sf",
                        },
                        {
                            title:"Задача",
                            type: 0,
                            maxLen: 60,
                            fieldId:"processItemName",
                            mode: "sfh",
                        },
                        {
                            title:"Данные",
                            type: 0,
                            maxLen: 60,
                            fieldId:"adminNote",
                            mode: "sf",
                        },
                        {
                            title:"Чек.тайм",
                            type: 2,
                            maxLen: 60,
                            fieldId:"lastCheck",
                            mode: "sf",
                            onView: (data,active)=>{
                                //console.log("x",data,active)
                                const txt = data?.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/) ? new Date(data)?.toLocaleString()?.substring(0,10) : "-"

                                return(
                                    <>{txt}</>
                                )
                            }
                        },



                    ]}
                    onPageCount={30}
                    data={orderList}
                    exportExcel={true}
                    onRecord={(e)=>{
                        setCurrentOrder(e)
                    }}
                    baseState={{
                        state: baseState,
                        setState: setBaseState
                    } }
                    saveState={true}
                    onReload={()=>loadOrderList(0)}



                ></TableItem>




        </div>
    )
}